import React from 'react';
import { FormBuilder } from 'commons-ui';
import useClone from './useClone';
import { LAUNCH_WIDGET_FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, launchWidgetValidationSchema } from '../utils/formConfig';

const CloneNotice: React.FC<{}> = () => {
	const { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useClone();

	return (
		<FormBuilder
			data={data}
			mode='create'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={launchWidgetValidationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={LAUNCH_WIDGET_FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
			dependencies={[]}
		/>
	);
};

export default CloneNotice;
